import { useState } from 'react';
import { bookingService } from '../services/bookingService';

export const useBookingActions = (onSuccess) => {
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAcceptPopup, setShowAcceptPopup] = useState(false);
  const [showAgreementPopup, setShowAgreementPopup] = useState(false);
  const [pendingBooking, setPendingBooking] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [bookingToEdit, setBookingToEdit] = useState(null);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');

  const executeAction = async (action) => {
    setActionLoading(true);
    setError(null);
    setShowErrorPopup(false);
    setErrorPopupMessage('');
    try {
      await action();
      if (onSuccess) onSuccess();
      return true; // Success
    } catch (err) {
      setError(err.message);
      // Show popup for any error
      if (err.message) {
        setErrorPopupMessage(err.message);
        setShowErrorPopup(true);
      }
      return false; // Failure
    } finally {
      setActionLoading(false);
    }
  };

  const acceptBooking = async (booking) => {
    // Show agreement popup first
    setPendingBooking(booking);
    setShowAgreementPopup(true);
  };

  const handleAcceptAgreement = async () => {
    if (!pendingBooking) return;
    
    setShowAgreementPopup(false);
    
    await executeAction(async () => {
      await bookingService.acceptBooking(pendingBooking.id);
      //setShowAcceptPopup(true);
    });
    
    setPendingBooking(null);
  };

  const handleAgreementClose = () => {
    setShowAgreementPopup(false);
    setPendingBooking(null);
  };

  const cancelBooking = async (bookingId) => {
    if (!window.confirm('Are you sure you want to cancel this booking?')) {
      return;
    }
    await executeAction(() => bookingService.cancelBooking(bookingId));
  };

  const editBookingDates = async (booking) => {
    setBookingToEdit(booking);
    setShowDatePicker(true);
  };

  const handleDatePickerSave = async (dates) => {
    if (!bookingToEdit) return;
    
    const success = await executeAction(async () => {
      await bookingService.editBookingDates(bookingToEdit.id, dates);
    });
    
    // Only close the modal if the operation was successful
    if (success) {
      setShowDatePicker(false);
      setBookingToEdit(null);
    }
  };

  const handleDatePickerClose = () => {
    setShowDatePicker(false);
    setBookingToEdit(null);
    setError(null); // Clear any errors when closing
  };

  return {
    actionLoading,
    error,
    acceptBooking,
    cancelBooking,
    editBookingDates,
    setError,
    showAcceptPopup,
    setShowAcceptPopup,
    showAgreementPopup,
    setShowAgreementPopup,
    handleAcceptAgreement,
    handleAgreementClose,
    pendingBooking,
    showDatePicker,
    bookingToEdit,
    handleDatePickerSave,
    handleDatePickerClose,
    showErrorPopup,
    setShowErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
  };
};
